import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { ApService } from 'src/app/shared/services/ap.service';
import { Timezone } from 'src/app/shared/model/timezone'
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import Chart from 'chart.js';
import { NovuTransactionsModalComponent } from '../../../novu-transactions-modal/novu-transactions-modal.component';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

import { resolveDeviceTimezone, deviceTimezoneLabel } from 'src/app/shared/helper/device-timezone';

@Component({
  selector: 'app-device-alert-device-state',
  templateUrl: './device-alert-device-state.component.html',
  styleUrls: ['./device-alert-device-state.component.scss']
})
export class DeviceAlertDeviceStateComponent implements OnInit {
  @Input() selfSort: any;
  @Input() set deviceInfo(obj) {
    if (obj) {
      this._device = obj;
    }
  }
  @Input() set dataSource(data) {
    data = data.map(v => ({...v, orderdate: v.orderdate ?? ""}))
    // for (let i = 0; i < data.length; i++) {
    //   const arr = data[i];
    //   arr["status"] = ""
    //   if(arr.lastSeen){
    //     arr["status"] = this.getStatus(arr.lastSeen,arr.track)
    //   } else {
    //     arr["status"] ="off"
    //   }
    // }
    // this.deviceArray = data;
    // this.domainChange();
    // setInterval(() => {
    //   this.domainChange()
    // }, 480000);
  };
  
  @Output() refresh = new EventEmitter<void>();
  @Output() sortChange = new EventEmitter<any>();
  
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  private listOfDeviceState: Subscription;
  
  chart: any;
  _device: any = []
  graphCount: any = []
  displayedColumns: string[] = ["Device State", "Last Seen", "Date Processed", "TransactionId", "Status", 'Action'];
  col: any;
  dir: any;
  _dataSource: MatTableDataSource<any>;
  deviceId = ""
  trackStatus = []
  searchMonthPipe = ""
  searchDatePipe = ""
  searchPipe = ""
  listOfMonths = []
  listOfDates = []
  selectedMonth = ""
  selectedDate = ""
  selectedTimezone = "America/New_York"
  selectedTabIndex: number = 0;
  upDeviceCnt = 0
  downDeviceCnt = 0
  warnDeviceCnt = 0
  deviceForm: any;
  monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
  ];
  timezoneArray = Timezone;
  loading = true;

  currentPage = 1;
  page = 0
  pageSize = 10
  length = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  pageEvent: PageEvent;

  constructor( private changeDetection: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    public apService: ApService,
    public dialog: MatDialog,
    private ref: ChangeDetectorRef,
    public route: ActivatedRoute,
    private router: Router,) { 
    this.deviceForm = this.formBuilder.group({
      searchMonth: new FormControl(null),
      searchDate: new FormControl(null),
      searchTimezone: new FormControl(null),
    });
    this._dataSource = new MatTableDataSource<any>();
  }

  
  ngOnInit(): void {
    // this._dataSource.data = this.tempData
    this.deviceId = this.route.snapshot.paramMap.get('device_id');
    this.getMonths()
    this.getDates()
    this.initMonthDate()
    this.selectedTimezone = resolveDeviceTimezone(this._device?.[0]?.statistics?.timezone);
    this.deviceForm.controls.searchTimezone.setValue(this.selectedTimezone);
    this.loadFilteredDates()
    if (this.router.url.includes("column=")) {
      let url = (this.router.url.split("?page=").pop()).split("&").splice(1, 2)
      this.col = url[0].split("=").pop()
      this.dir = url[1].split("=").pop()
      if (this.dir == 'asc') {
        this.sortData({ active: `${this.col}`, direction: 'asc' })
      } else if (this.dir == 'desc') {
        this.sortData({ active: `${this.col}`, direction: 'desc' })
      }
    }
  }
  ngAfterViewInit() {
    if (this.selfSort) {
      this.paginator.length = this.length;
      this._dataSource.paginator = this.paginator;
      this._dataSource.sort = this.sort;
      this.changeDetection.markForCheck();
    } else {
      this.sort.sortChange.subscribe(() => {
        this.sortChange.emit(this.sort)
      });
    }
    this.changeDetection.detectChanges();
  }
  initMonthDate(){
    var today = new Date();
    this.selectedMonth = this.monthNames[today.getMonth()] + ' - ' +today.getFullYear()
    this.selectedDate = today.getDate().toString()
    this.deviceForm.controls.searchMonth.setValue(this.selectedMonth);
    this.deviceForm.controls.searchDate.setValue(this.selectedDate);
  }
  displayDeviceState(state){
    if(state == 1){
      return "On"
    } else if(state == 2) {
      return "Warn"
    } else {
      return "Off"
    }
  }
  displayStatus(status){
    if( status == true) {
      return "Sent"
    } else {
      return "Failed"
    }
  }
  displayTimezone(tz){
    return deviceTimezoneLabel(tz);
  }
  displayFormatTimeZone(date,tz){
    const tzone = resolveDeviceTimezone(this.selectedTimezone || tz);
    return moment(date).tz(tzone).format('ddd MMM D YYYY HH:mm:ss zz')
  }
  private destroyChart() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }
  private createDoughnutChart(canvasId: string, data: number[]) {
    const canvas = document.getElementById(canvasId) as HTMLCanvasElement | null;
    const context = canvas?.getContext('2d');
    if (!canvas || !context) {
      return null;
    }
    return new Chart(context, {
      type: 'doughnut',
      data: {
        labels: ['Online', 'Offline', 'Warning'],
        datasets: [
          {
            data,
            backgroundColor: ['#34a854', '#e81123', '#cf853e'],
            fill: false
          },
        ]
      },
      options: {
        legend: {
          display: false
        },
        tooltips: {
          enabled: true
        }
      }
    });
  }
  drawDeviceChart() {
    this.destroyChart();
    this.upDeviceCnt = 100 - parseInt(this.graphCount.down)
    this.warnDeviceCnt = parseInt(this.graphCount.warn)
    this.downDeviceCnt = parseInt(this.graphCount.down)
    this.chart = this.createDoughnutChart('canvas', [this.upDeviceCnt, this.downDeviceCnt]);

  }
  getMonths(){
    var today = new Date();

    for (let i = 0; i < 3; i++) {
      this.listOfMonths.push(this.monthNames[(today.getMonth() - i)] + ' - ' +today.getFullYear()  );
    }
  }
  getDates(){
    this.listOfDates = []
    var selection = ""
    var curMonth = new Date().getMonth();
    var numDays = 0
    if(this.selectedMonth == ""){
      selection = new Date().getFullYear() + "-" + new Date().getMonth()
      numDays = new Date().getDate();
      
    } else {
      const m = this.selectedMonth.split(" - ")
      selection = m[1] +"-"+ (this.monthNames.indexOf(m[0]) +1)
      if(this.monthNames.indexOf(m[0]) === curMonth) {
        numDays = new Date().getDate();
      } else {
        numDays = moment(selection, "YYYY-MM").daysInMonth()
      }
    }
    for (let i = numDays; i >= 1; i--) {
      this.listOfDates.push(i.toString());
    }
    this.deviceForm.controls.searchDate.setValue(numDays.toString());
  }
  handlePageEvent(event: PageEvent) {
    this.currentPage = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.loadFilteredDates()
  }
  loadCustomizedDate(){
    const my = this.selectedMonth.split(' - ')
    const month = this.monthNames.indexOf(my[0]) + 1
    const year = my[1]
    const day = this.selectedDate
    const dateFrom = moment(year+"-"+month+"-"+day+" 00:00:00Z").toISOString()
    const dateTo = moment(year+"-"+month+"-"+day+" 23:59:59Z").toISOString()
    this.loadDeviceStates(dateFrom, dateTo)
  }
  loadDeviceStates(dateFrom, dateTo){    
    const request =   {
      deviceId: this.deviceId,     
      date_from: dateFrom,
      date_to: dateTo,
      page: this.currentPage,
      pageSize: this.pageSize
    }    
    this.apService.getDeviceState(request).subscribe(res=>{
      this.loading = false
      this._dataSource.data = res.data
      this.length = parseInt(res.count.all)
      this.drawDeviceChart();
    })
  }
  loadDeviceCalc(dateFrom, dateTo, type){    
    const request =   {
      deviceId: this.deviceId,     
      date_from: dateFrom,
      date_to: dateTo,
      type: type
    }    
    this.apService.getDeviceCalc(request).subscribe(res=>{
      this.loading = false
      this.graphCount = res.data
      this.drawDeviceChart();
    })
  }
  loadFilteredDates(){
    let ed, sd
    switch (this.selectedTabIndex) {
      case 0: // 4 hrs
        ed = moment(new Date()).toISOString()
        sd = moment(new Date(new Date(ed).getTime() - (4 * 60 * 60 * 1000))).toISOString()
        this.loadDeviceStates(sd, ed)
        this.loadDeviceCalc(sd, ed, 0)
        break;
    
      case 1: // 24 hrs
        ed = moment(new Date()).toISOString();
        sd = moment(new Date(new Date(ed).getTime() - (24 * 60 * 60 * 1000))).toISOString();
        this.loadDeviceStates(sd, ed)
        this.loadDeviceCalc(sd, ed, 1)
        break;

      case 2: // 7 days
        ed = moment(new Date()).toISOString()
        sd = moment(new Date(new Date(ed).getTime() - (7 * 24 * 60 * 60 * 1000))).toISOString()
        this.loadDeviceStates(sd, ed)
        this.loadDeviceCalc(sd, ed, 2)
        break;
    
      case 3: // this month
        ed = moment(new Date()).toISOString()
        sd = moment(ed).startOf('month').toISOString(); 
        this.loadDeviceStates(sd, ed)
        this.loadDeviceCalc(sd, ed, 3)
        break;

      case 4: // last month
        ed =moment(new Date()).subtract(1, 'months').endOf('month').toISOString(); 
        sd = moment(ed).startOf('month').toISOString()
        this.loadDeviceStates(sd, ed)
        this.loadDeviceCalc(sd, ed, 4)
        break;

      default:
        break;
    }   
  }
  loadTab(){
    if(this.router.url.includes("?type=")){
      let url = this.router.url.split("?type=").pop().split("-").reverse()
      this.selectedTabIndex = Number(url[0]) - 1;
      this.changeDetection.detectChanges();
    }
  }
  onSelectionMonthChange(event){
    if(event.value){
      this.selectedMonth = event.value;
      this.getDates()
      
    }
  }
  onSelectionTZChange(event){
    if(event.value){
      this.selectedTimezone = event.value;
      this.loadFilteredDates()
    }
  }
  onSelectionDateChange(event){
    if(event.value){
      this.selectedDate = event.value;
      this.loadCustomizedDate();
    }
  }
  searchMonthFocus(){
    // setTimeout(() => {
    //   this.searchElement.nativeElement.focus();
    // }, 50);
  } 
  searchDateFocus(){
    // setTimeout(() => {
    //   this.searchElement.nativeElement.focus();
    // }, 50);
  }
  searchFocus(){

  }
  sortData(sort: Sort) {
    if (this.selfSort) {
      const data = this.trackStatus.slice();
      if (!sort.active || sort.direction === '') {
        this._dataSource.data = data;
        return;
      }

      function compare(a: number | string, b: number | string, isAsc: boolean) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
      }

      this._dataSource.data = data.sort((a, b) => {
        const isAsc = sort.direction === 'asc';
        switch (sort.active) {
          case 'Device State': return compare(a.lastDeviceState, b.lastDeviceState, isAsc);
          case 'Timezone': return compare(a.timezone, b.timezone, isAsc);
          case 'Last Seen': return compare(a.lastSeen, b.lastSeen, isAsc);
          case 'Date Processed': return compare(a.novuDateProcessed, b.novuDateProcessed, isAsc);
          case 'TransactionId': return compare(a.novuTransactionId, b.novuTransactionId, isAsc);
          case 'Status': return compare(a.isDeviceAlertSent, b.isDeviceAlertSent, isAsc);
          // case 'status': return compare(this.getStatus(a.lastSeen, a.track), this.getStatus(b.lastSeen,b.track), isAsc);
          default: return 0;
        }
      });
    }

    if (this.router.url.includes("page=")) {
      let url;
      if (this.router.url.includes("column")) {
        url = this.router.url.split("&column").shift()
        if (sort.direction == 'asc') {
          this.router.navigateByUrl(url + '&column=' + sort.active + '&order=asc');
        } else if (sort.direction == 'desc') {
          this.router.navigateByUrl(url + '&column=' + sort.active + '&order=desc');
        } else {
          if (this.router.url.includes("page=1")) {
            this.router.navigateByUrl("/layout/devices")
          } else {
            this.router.navigateByUrl(url);
          }
        }
      } else {
        if (sort.direction == 'asc') {
          this.router.navigateByUrl(this.router.url + '&column=' + sort.active + '&order=asc');
        } else if (sort.direction == 'desc') {
          this.router.navigateByUrl(this.router.url + '&column=' + sort.active + '&order=desc');
        } else {
          this.router.navigateByUrl(this.router.url);
        }
      }
    } else {
      if (sort.direction == 'asc') {
        this.router.navigateByUrl(this.router.url + '?page=1&column=' + sort.active + '&order=asc');
      } else if (sort.direction == 'desc') {
        this.router.navigateByUrl(this.router.url + '?page=1&column=' + sort.active + '&order=desc');
      } else {
        this.router.navigateByUrl(this.router.url);
      }
    }
  }
  selectedTabChange(event){
    if(event) {
      this.selectedTabIndex = event.index
      this.loadFilteredDates()
    }
  }
  viewNovu(data): void {
    const dialogRef = this.dialog.open(NovuTransactionsModalComponent, {
      disableClose: true,
      width: '1000px',
      data: { data, showDevice: true},      
    });

    dialogRef.afterClosed().subscribe(result => {
      // this.loadData();
    });
  }
}
